var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.title,style:({
    paddingTop: _vm.pt + 'px',
    paddingRight: _vm.pr + 'px',
    paddingBottom: _vm.pb + 'px',
    paddingLeft: _vm.pl + 'px',
  }),attrs:{"title":_vm.title}},[_vm._v(" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }